import React from 'react'
import './ToutesActualites.css' ;
import { Footer , Header , Actualites} from '../index';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';


function ToutesActualites() {
    const location = useLocation();

        // Vérifiez d'abord si des informations ont été transmises
        if (location.state && location.state.information) {
            // Si des informations ont été transmises, affichez-les dans la console
            console.log('Informations reçues :', location.state.information);
        } else {
            // Si aucune information n'a été transmise, affichez un message
            console.log('Aucune information reçue');
        }
  return (
    <>
        <Header/>


        <div className='containerActualité'>
        <div className='bgActualité'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-130px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy',fontSize:'40px'}} className="container-fluid text-white text-center " id='h1ac'>Actualités & événements</h1>
          <p ><Link className='linkActualité' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkActualité'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkActualité'
            to="/ToutesActualités">Actualités</Link></p></div>

      </div>
      

   

        <Actualites/>

        <Footer/>

    </>
    )
}

export default ToutesActualites